export const getEquipments = (token, merchantId) => (payload) => ({
  endpoint: `/api/v1/payment-terminals/merchant/${merchantId}`,
  proxy: false,
  method: 'GET',
  headers: {
    'X-Authentication-Token': token,
  },
  cache: true,
  force: payload && payload.force,
  formData: payload,
  parseResponse: (response) => response.data.data,
});

export const pathEquiments = (data) => ({
  endpoint: `/api/v1/payment-terminals/${data.values.entityId}`,
  proxy: false,
  method: 'PUT',
  headers: {
    'X-Authentication-Token': data.token,
  },
  data: {
    'subsidiaryId': data.values.subsidiaryId,
    'alias': data.values.alias
  },
})

export const deleteEquiments = (id, token) => ({
  endpoint: `/api/v1/payment-terminals/${id}`,
  proxy: false,
  method: 'DELETE',
  headers: {
    'X-Authentication-Token': token,
  },
  formData: {
    id,
    token,
    channel: 'web',
    deviceId: 'web',
    deviceModel: 'web',
    deviceOS: 'web',
  },
  parseResponse: (response) => response.data.data,
});
